const STORAGE_PREFIX = 'ptb_';
const BEST_SCORE_KEY = STORAGE_PREFIX + 'bestScore';
let playablesStoreCache = null;
let playablesStoreLoadPromise = null;

function getYtgame() {
  if (typeof window === 'undefined') return null;
  return window.ytgame || null;
}

function isPlayablesEnv() {
  const ytgame = getYtgame();
  return !!(ytgame && ytgame.IN_PLAYABLES_ENV);
}

function getDefaultStoreData() {
  return {
    selectedSkin: {
      value: 0
    },
    user: {
      score: 0
    },
    coins: {
      value: 0
    },
    bomb: {
      value: -1
    },
    rocket: {
      value: -1
    },
    swap: {
      value: -1
    },
    hammer: {
      value: -1
    },
    soundAccess: {
      value: true
    },
    level: {
      value: 1
    },
    Maxlevel: {
      value: 1
    }
  };
}

function normalizePayload(payload) {
  if (payload && typeof payload === 'object' && 'value' in payload) return payload;
  return {
    value: payload
  };
}

function loadFromStorage(keys) {
  const out = {};
  const defaults = getDefaultStoreData();
  try {
    for (const key of keys) {
      const raw = localStorage.getItem(STORAGE_PREFIX + key);
      if (raw != null) {
        try {
          const parsed = JSON.parse(raw);
          out[key] = normalizePayload(parsed);
        } catch (_) {
          out[key] = defaults[key] != null ? defaults[key] : {
            value: null
          };
        }
      } else if (defaults[key] !== undefined) {
        out[key] = defaults[key];
      }
    }
  } catch (_) {
    return getDefaultStoreData();
  }
  return out;
}

function saveToStorage(key, payload) {
  try {
    if (payload && typeof payload.value !== 'undefined') {
      localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(payload));
    }
  } catch (_) {}
}

async function loadPlayablesStore() {
  if (!isPlayablesEnv()) return null;
  if (playablesStoreCache) return playablesStoreCache;
  if (playablesStoreLoadPromise) return playablesStoreLoadPromise;

  playablesStoreLoadPromise = (async () => {
    try {
      const raw = await getYtgame().game.loadData();
      const parsed = raw ? JSON.parse(raw) : {};
      playablesStoreCache = parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_) {
      playablesStoreCache = {};
    }
    return playablesStoreCache;
  })();

  return playablesStoreLoadPromise;
}

async function getFromPlayablesStore(keys) {
  const store = await loadPlayablesStore();
  const defaults = getDefaultStoreData();
  const out = {};
  for (const key of keys) {
    if (store && Object.prototype.hasOwnProperty.call(store, key)) {
      out[key] = normalizePayload(store[key]);
    } else if (defaults[key] !== undefined) {
      out[key] = defaults[key];
    }
  }
  return out;
}

async function saveToPlayablesStore(key, payload) {
  const store = await loadPlayablesStore();
  if (!store) return;
  store[key] = payload;
  playablesStoreCache = store;
  try {
    await getYtgame().game.saveData(JSON.stringify(store));
  } catch (_) {}
}

const eventListeners = {};
function addEventListener(eventName, callback, priority) {
  if (!eventListeners[eventName]) eventListeners[eventName] = [];
  eventListeners[eventName].push({
    callback,
    priority: priority || 0
  });
  eventListeners[eventName].sort((a, b) => b.priority - a.priority);
}
function emit(eventName, payload) {
  const list = eventListeners[eventName];
  if (!list) return;
  for (const {
    callback
  } of list) {
    try {
      callback(payload);
    } catch (e) {}
  }
}
const platform = {
  init() {
    setTimeout(() => emit('onLoadingStart'), 0);
  },
  notifyLoadingComplete() {
    emit('onLoadingEnd');
  },
  notifyLoadingProgress(_progress, _bool) {},
  getPlayerInfo() {
    return {
      playerPic: null
    };
  },
  notifyLevelStart(_levelId) {},
  notifyLevelEnd(_levelId, _score, _success) {},
  getName() {
    return isPlayablesEnv() ? 'youtube' : 'dev';
  }
};
const storeModule = {
  async get(keys) {
    const keyList = Array.isArray(keys) ? keys : [keys];
    if (isPlayablesEnv()) {
      return getFromPlayablesStore(keyList);
    }
    return loadFromStorage(keyList);
  },
  async save(key, payload) {
    if (isPlayablesEnv()) {
      await saveToPlayablesStore(key, payload);
      return;
    }
    saveToStorage(key, payload);
  }
};
const analyticsModule = {
  onCustomEvent(_name, _value) {}
};
const profileModule = {
  getOpponent() {
    return Promise.resolve(null);
  },
  getProfiles(numProfiles, minScore, maxScore, step) {
    const count = numProfiles || 10;
    const minS = minScore || 50000;
    const maxS = maxScore || 100000;
    const names = ['Bot1', 'Bot2', 'Bot3', 'Bot4', 'Bot5', 'Player', 'Rival', 'Challenger', 'Guest', 'Pro'];
    const list = [];
    for (let i = 0; i < count; i++) {
      const score = minS + Math.floor(Math.random() * (maxS - minS + 1));
      list.push({
        id: `mock_${i}`,
        name: names[i % names.length] + (i >= names.length ? i : ''),
        score,
        color: null,
        invite: null,
        leaderColor: null,
        rank: null
      });
    }
    return Promise.resolve(list);
  }
};
const i18nModule = {
  getTranslation(key) {
    return Promise.resolve(key);
  }
};
const scoreModule = {
  async getBestScore() {
    if (isPlayablesEnv()) {
      const data = await getFromPlayablesStore(['bestScore']);
      const value = data.bestScore?.value != null ? parseInt(data.bestScore.value, 10) : 0;
      return isNaN(value) ? 0 : value;
    }
    try {
      const raw = localStorage.getItem(BEST_SCORE_KEY);
      const value = raw != null ? parseInt(raw, 10) : 0;
      return isNaN(value) ? 0 : value;
    } catch (_) {
      return 0;
    }
  },
  async setBestScore(score) {
    const n = typeof score === 'number' && !isNaN(score) ? score : 0;
    if (isPlayablesEnv()) {
      await saveToPlayablesStore('bestScore', {
        value: n
      });
      try {
        if (getYtgame()?.engagement?.sendScore) {
          await getYtgame().engagement.sendScore({
            value: parseInt(n, 10)
          });
        }
      } catch (_) {}
      return;
    }
    try {
      localStorage.setItem(BEST_SCORE_KEY, String(n));
    } catch (_) {}
  }
};
const mock = {
  addEventListener,
  getPlatform() {
    return platform;
  },
  getStoreModule() {
    return storeModule;
  },
  getAnalyticsModule() {
    return analyticsModule;
  },
  getProfileModule() {
    return profileModule;
  },
  getI18nModule() {
    return i18nModule;
  },
  getScoreModule() {
    return scoreModule;
  }
};
export default mock;
